import ddt from '@wix/da-ddt';

export function requestNotificationPermission(): Promise<NotificationPermission> {
  return new Promise(function (resolve, reject) {
    const permissionResult = Notification.requestPermission(function (result) {
      resolve(result);
    });
    try {
      permissionResult.then(resolve, reject);
    } catch (error) {
      if (error instanceof TypeError) {
        // Safari uses a deprecated callback version of Notification.requestPermission
        // https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission_static#syntax
        void Notification.requestPermission(resolve);
      } else {
        ddt.log('pwa', 'Error thrown for push notifications permission');
        throw error;
      }
    }
  });
}
